import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Heart } from 'lucide-react';
import { organizationInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Programs', path: '/programs' },
    { name: 'Caregivers', path: '/caregivers' },
    { name: 'Resources', path: '/resources' },
    { name: 'Events', path: '/events' },
    { name: 'Contact', path: '/contact' },
  ];

  const supportLinks = [
    { name: 'Get Support', path: '/resources' },
    { name: 'Volunteer', path: '/get-involved' },
    { name: 'Donate', path: '/get-involved' },
    { name: 'Partner With Us', path: '/get-involved' },
  ];

  return (
    <footer className="bg-[#2D2A32] text-white">
      {/* Wave Decoration */}
      <div className="h-16 bg-gradient-to-b from-[#F5F0EB] to-[#2D2A32]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src={organizationInfo.logo}
                alt={organizationInfo.name}
                className="h-20 w-auto bg-white rounded-lg p-2"
              />
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed">
              {organizationInfo.mission}
            </p>
            <div className="flex space-x-4">
              <a
                href={organizationInfo.socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-[#E07A5F] transition-colors duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={organizationInfo.socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-[#E07A5F] transition-colors duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={organizationInfo.socialLinks.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 rounded-full hover:bg-[#E07A5F] transition-colors duration-300"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#E07A5F]">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#E07A5F] transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#E07A5F]">Get Involved</h3>
            <ul className="space-y-3">
              {supportLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#E07A5F] transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#E07A5F]">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#E07A5F] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">{organizationInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#E07A5F] flex-shrink-0" />
                <a
                  href={`tel:${organizationInfo.phone}`}
                  className="text-gray-300 hover:text-[#E07A5F] transition-colors text-sm"
                >
                  {organizationInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#E07A5F] flex-shrink-0" />
                <a
                  href={`mailto:${organizationInfo.email}`}
                  className="text-gray-300 hover:text-[#E07A5F] transition-colors text-sm"
                >
                  {organizationInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {organizationInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm flex items-center">
              Made with <Heart className="w-4 h-4 mx-1 text-[#E07A5F]" /> in Hawaii
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
